module.exports = __webpack_public_path__ + "images/1a7eaa01f6cbf9b3ef8e11a85ebb6285.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/spankki.png
// module id = 1526
// module chunks = 1